import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import ThemeConstants from '../../../../theme/ThemeConstants';

const styles = {
  toolbar: {
    borderTop: '2px solid',
    color: 'common.lightBackgroundColor',
    minHeight: '50px !important',
    flexWrap: 'wrap',
    padding: '0 !important',
  },
  navButton: {
    marginRight: '24px',
    minHeight: '21px !important',
  },
  activeButton: {
    borderBottom: '2px solid',
    borderRadius: 0,
    fontWeight: '600',
  },
  inActiveButton: {
    color: ThemeConstants.grey[500],
    fontSize: 14,
    fontWeight: '400',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
